import cn from 'classnames'
import React from 'react'
import SvgSearch from 'src/components/Svgs/SvgSearch'

import styles from './UtilityToolbarSearch.style'

export interface UtilityToolbarSearchProps {
  value: string
  onChange: (v: string) => void
  placeholder: string
  noHeader?: boolean
}

const UtilityToolbarSearch: React.FC<UtilityToolbarSearchProps> = (
  {
    noHeader = false,
    ...props
  },
): React.ReactElement => {
  return (
    <div className={cn("UtilityToolbarSearch", { noHeader })}
      css={styles}
    >
      <div
        className={"UtilityToolbarSearch container"}
      >
        <SvgSearch className="UtilityToolbarSearch icon" />
        <input
          data-testid={'keywordFilterInput'}
          className={"UtilityToolbarSearch input"}
          placeholder={props.placeholder}
          type={'text'}
          value={props.value}
          onChange={(e): void => {
            props.onChange(e.target.value)
          }}
        />
      </div>
    </div>
  )
}

export default UtilityToolbarSearch
